// extracted by mini-css-extract-plugin
module.exports = {"dot":"kS","department":"kT","departmentContent":"kU","departmentbiggerText":"kV","departmentText":"kW"};